import { useState, useRef} from 'react';
import CompListArea from "./area/comp_list";

function CompStuPrescribeCompListArea(props: any) {
  let myProps = {
    ...props
  };

  

  return (
    <div>
      <table style={{ width: "100%" }}>
        <colgroup>
          <col width="20%"></col>
          <col width="*"></col>
        </colgroup>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top" }}>
              <div style={{ minWidth: "300px" }}>
                <CompListArea></CompListArea>
              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div style={{ minWidth: "21cm" }}>

              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default CompStuPrescribeCompListArea;